/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { LockCircledIcon } from '@coursera/cds-icons';

import { isFreemiumModelRolloutGAEnabled } from 'bundles/enroll-common/utils/freemiumModelUtils';

const styles = {
  icon: (isFreemiumGAEnabled: boolean) => css`
    ${isFreemiumGAEnabled &&
    `
      path {
        fill: var(--cds-color-neutral-primary-weak);
      }`}

    circle {
      fill: ${isFreemiumGAEnabled ? 'var(--cds-color-emphasis-neutral-background-weak)' : 'var(--cds-color-blue-700)'};
    }
  `,
};
type Props = {
  size?: number;
  title?: string;
};

/**
 * @deprecated This is just a CDS icon wrapper and we should use CDS icon directly in the caller
 */
const PremiumLockIcon = (props: Props) => {
  const isFreemiumGAEnabled = isFreemiumModelRolloutGAEnabled();
  const { size = 16, title = 'Premium' } = props;

  return (
    <LockCircledIcon
      css={styles.icon(isFreemiumGAEnabled)}
      title={title}
      color="invert"
      data-testid="premium-lock-icon"
      {...(isFreemiumGAEnabled ? { size: 'medium' } : { style: { width: size, height: size } })}
    />
  );
};

export default PremiumLockIcon;
